import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { RouteAction } from '@core/action/action';
import { NZ_I18N, pt_BR } from 'ng-zorro-antd/i18n';
import { MovimentacaoSocietariaListComponent } from './pages/movimentacao-societaria-list/movimentacao-societaria-list.component';
import { MovimentacaoSocietariaNaturezaMudancaComponent } from './pages/movimentacao-societaria-natureza-mudanca/movimentacao-societaria-natureza-mudanca.component';
import { MovimentacaoSocietariaMudancaSocietariaComponent } from './pages/movimentacao-societaria-mudanca-societaria/movimentacao-societaria-mudanca-societaria.component';

const routes: Routes = [

  {
    path: '',
    component: MovimentacaoSocietariaListComponent,
    canActivate: [AuthGuardService],
    data: {
      acao: RouteAction.Visualizar,
      headerPage: {
        titlePage: '',
        subTitlePage: '',
      },
    },
  },
  {
    path: 'mudanca-societaria',
    component: MovimentacaoSocietariaMudancaSocietariaComponent,
    data: {
      acao: RouteAction.Inserir
    },
  },
  {
    path: 'natureza-mudanca',
    component: MovimentacaoSocietariaNaturezaMudancaComponent,
    data: {
      acao: RouteAction.Visualizar,
    },
  },
  {
    path: 'mudanca-societaria/inserir',
    component: MovimentacaoSocietariaMudancaSocietariaComponent,
    data: {
      acao: RouteAction.Inserir,
    },
  },
  {
    path: 'mudanca-societaria/editar/:id',
    component: MovimentacaoSocietariaMudancaSocietariaComponent,
    data: {
      acao: RouteAction.Editar,
    },
  },  {
    path: 'mudanca-societaria/visualizar/:id',
    component: MovimentacaoSocietariaMudancaSocietariaComponent,
    data: {
      acao: RouteAction.Visualizar,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [{ provide: NZ_I18N, useValue: pt_BR }],
  exports: [RouterModule]
})
export class MovientacaoSocietariaRoutingModule { }
